import { useStream } from '../stream/stream';

const LABELS = {
  connected: 'Live',
  connecting: 'Connecting…',
  reconnecting: 'Reconnecting…',
  disconnected: 'Offline',
} as const;

/** The connection to the server and the price feed, so a trader always knows whether the numbers on screen are live. */
export function ConnectionStatus() {
  const hubState = useStream((s) => s.hubState);
  const feedUp = useStream((s) => s.feedUp);
  const live = hubState === 'connected';
  const prices = !live ? null : feedUp === false ? 'Prices paused' : 'Prices live';
  const tone = !live ? 'bg-warn' : feedUp === false ? 'bg-down' : 'bg-up';

  return (
    <div
      className="flex items-center gap-2 text-sm"
      role="status"
      aria-live="polite"
      data-testid="connection-status"
    >
      <span className={`inline-block h-2.5 w-2.5 rounded-full ${tone}`} aria-hidden="true" />
      <span>{LABELS[hubState]}</span>
      {prices && <span className="text-muted">· {prices}</span>}
    </div>
  );
}
